import { render } from "./WhiteList.vue?vue&type=template&id=60aa1e62&scoped=true"
import script from "./WhiteList.vue?vue&type=script&lang=js"
export * from "./WhiteList.vue?vue&type=script&lang=js"

import "./WhiteList.vue?vue&type=style&index=0&id=60aa1e62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60aa1e62"]])

export default __exports__